import request from '@/utils/request'
// import debugLog from '@/utils/debugLog'

const urlBase = '/sales_slips/'

export function getSalesSlips(params) {
  // debugLog(params)
  return request({
    url: urlBase,
    method: 'get',
    params: params
  })
}

export function getSalesSlip(id) {
  if (id) {
    return request({
      url: urlBase + id,
      method: 'get'
    })
  } else {
    return request({
      url: urlBase + 'new',
      method: 'get'
    })
  }
}

export function patchSalesSlip(record) {
  const rec_id = record.id
  delete record.id
  return request({
    url: urlBase + rec_id,
    method: 'patch',
    data: {sales_slip: record}
  })
}

export function postSalesSlip(record) {
  delete record.id
  return request({
    url: urlBase,
    method: 'post',
    data: {sales_slip: record}
  })
}
